export const ROUTES = {
  HOME: '/react-store',
  CART: '/react-store/cart',
  PROFILE: '/react-store/profile',
  PRODUCT: '/react-store/products/:id',
  CATEGORY: '/react-store/categories/:id',
};
